import React, { useEffect, useState } from "react";
import axios from "axios";
import "./index.css";
import Icons from "../../../../components/icons";
import env from "../../../../config/env";
import { useAppServices } from "../../../../hook/services";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";

const Modal = ({ isOpen, onClose, children }) => {
  const BASE_URL = `${env.API_URL}/v1`;
  return (
    <>
      {isOpen && (
        <div className="modal-overlay" onClick={onClose}>
          <div
            className="modal-content-share text-center"
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
};

// Example usage in another component
const ForgetModel = ({
  isModalOpen,
  justCloseIt,
}) => {
  const [processing, setProcessing] = useState(false);
  const Service = useAppServices();
  const [whitelabel, setwhitelabel] = useState("");
  const BASE_URL = `${env.API_URL}/v1`;

  const getting_whitelable_domain = async () => {
    const currentURL = window.location.href;
    const urlObject = new URL(currentURL);
    const domain = urlObject.hostname;
    const payload = {
      domain: domain,
    };
    const { response, error } = await Service.agency.getwhitelabel({
      payload: payload,
    });
    if (response) {
      setwhitelabel(response.data);
    }
  };
  useEffect(() => {
    getting_whitelable_domain();
  }, []);

  // prompt payload states
  const [email, setemail] = useState();

  // error status
  const [emailError, setemailError] = useState(null);

  const resetAddUserForm = () => {
    setemail("");
  };

  const handleClose = () => {
    justCloseIt();
  };
  const handleAddUserSubmit = async () => {
    setemailError(null);

    if (!email) {
      setemailError("Email is required");
      return;
    }
    setProcessing(true);
    try {
      const response = await axios.post(`${BASE_URL}/user/forgot-password`, {
        email: email,
        agency_id: whitelabel?._id || "6739f1be347a7f5974735cec",
      });
      if (response) {
        handleClose();
        toast.success("Please check your email to reset your password.");
      }
      setProcessing(false);
    } catch (error) {
      console.log('error', error)
      if (error?.response) {
        setemailError(error?.response?.data?.message)
      }
      setProcessing(false);
    }
  };

  return (
    <div>

      <Modal isOpen={isModalOpen}>
        <div className="scrollable-modal-content">
          <div style={{ position: "relative" }}>
            <p
              style={{
                position: "absolute",
                right: 0,
                width: "12px",
                height: "12px",
                cursor: "pointer",
              }}
              onClick={handleClose}
            >
              X
            </p>

            <p className="modalText">Forgot Password?</p>
            <div className="formGroup" style={{ marginBottom: "20px" }}>
              <label>Email</label>
              <input
                type="text"
                name="email"
                placeholder="Email"
                className="flex-1 modalInputs"
                value={email}
                onChange={(e) => {
                  setemail(e.target.value);
                  setemailError(null);
                }}
              />
              {emailError && (
                <div className="text-red-500" >
                  There is no user with this email address registered please{" "}
                  <Link
                    to="/auth/sign-up"
                    className="underline font-medium"
                    onClick={(e) => e.stopPropagation()}
                  >
                    sign up here.
                  </Link>
                </div>
              )}
            </div>


            <p
              className="disagreeBtn"
              style={{
                margin: 0,
                width: "100%",
                opacity: processing ? 0.6 : 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              disabled={processing}
              onClick={handleAddUserSubmit}
            >
              {processing && <Icons id="spinner" color="black" />}
              Get Password Now
            </p>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ForgetModel;
